import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Card,
  Button,
  Table,
  Select,
  Input,
} from "antd";
import {
  getNowAcademicYear,
  getNowAcademicSemester,
  formateDateDbT,
} from "../../utils/dateUtil";
import { usrRole } from "../../utils/dataUtil";
import { req_list_aps_coursese_qa } from "../../api";
class AiCourseResponse extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    deviceWidth: 0,
    loading: false,
    academicYear: getNowAcademicYear(new Date()),
    academicSemester: getNowAcademicSemester(new Date()),
    userLevel: "NORMAL",
    items: [],
    item: {},
    searchField: "NONE",
    searchValue: "",
    filterStatus: "",
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentWillMount() {
    this.api_list_items();
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_list_items = async () => {
    const {
      searchField,
      searchValue,
      filterStatus,
      academicYear,
      academicSemester,
    } = this.state;
    const { token, userCode, role } = this.props.user;

    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });
    this.setState({ loading: true });
    const result = await req_list_aps_coursese_qa(
      userLevel,
      userCode,
      searchField,
      searchValue,
      filterStatus,
      academicYear,
      academicSemester,
      token
    );
    this.setState({ loading: false });
    //console.log(result)
    if (result.total > 0) {
      const items = result.data;
      this.setState({ items });
      //console.log(this.state);
    } else {
      const items = [];
      this.setState({ items });
    }
  };

  // 操作互動處理 //////////////////////////////////////////////

  /////////////////////////////////////////////////////////////
  init_columns = () => {
    this.columns = [
      {
        title: "學年度",
        dataIndex: "AcademicYear",
        width: 10,
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "學期",
        dataIndex: "Semester",
        width: 10,
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "課程名稱",
        dataIndex: "RequestTopic",
        width: 50,
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "提問學生",
        dataIndex: "RequestUserName",
        width: 50,
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "提問內容",
        dataIndex: "RequestDescription",
        width: 50,
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "提問日期",
        dataIndex: "RequestDatetime",
        width: 50,
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.3em" }}>
                {" "}
                {formateDateDbT(field)}
              </span>
            </div>
          );
        },
      },
      {
        title: "AI回應",
        dataIndex: "ResponseDescription",
        width: 50,
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1em" }}> {field}</span>
            </div>
          );
        },
      },
    ];
  };

  render() {
    const { loading, items, searchField, searchValue, filterStatus } =
      this.state;
    const title = (
      <>
        <Input
          placeholder="課程名稱"
          style={{ width: 80, margin: "0 5px" }}
          value={filterStatus}
          onChange={(event) =>
            this.setState({ filterStatus: event.target.value })
          }
        />
        <Select
          value={searchField}
          style={{ width: 120 }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="NONE">搜索條件</Select.Option>
          <Select.Option value="RequestUserId">學號</Select.Option>
          <Select.Option value="RequestUserName">姓名</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 80, margin: "0 5px" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_list_items()}>
          <i className="fas fa-search element-hidden"></i>
          <span style={{ marginLeft: "4px" }}>查詢</span>
        </Button>
      </>
    );
    return (
      <div>
        <Card title={title}>
          <Table
            bordered
            scroll={{ x: 800 }}
            loading={loading}
            rowKey="Id"
            dataSource={items}
            pagination={false}
            columns={this.columns}
          />
        </Card>
      </div>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(AiCourseResponse);
